<template>
  <div class="pageMain zone-page" :class="globalDataArray.siteInfo.greyOut == 1 ? 'bigEventGray' : ''">
    <!-- Banner轮播区域 -->
    <div v-swiper:zoneSwiper="swiperOption" class="zone-banner">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(banner, index) in banners" :key="'banner' + index">
          <div class="banner-item">
            <img :src="banner.image" :alt="banner.title" class="banner-image">
          </div>
        </div>
      </div>
    </div>

    <!-- 搜索框 -->
    <div class="search-box-container">
      <div class="search-second">
        <div class="search-box">
          <div class="search-icon"></div>
          <input
            type="text"
            class="search-input"
            :placeholder="globalDataArray.siteTemplateLanguage.zone_search_placeholder"
            v-model="search"
            @keyup.enter="getZoneList"
          >
        </div>
      </div>
    </div>

    <!-- 主内容区域 -->
    <div class="zone-container">
      <!-- 赛区列表 -->
      <ul class="zone-list">
        <li v-for="item in zoneListing" :key="item.id" class="zone-card">
          <router-link class="zone-link" :to="'/competition?zone_id=' + item.parentId">
            <!-- 卡片图片和时间标签 -->
            <div class="card-image-container">
              <img :src="item.image" :alt="item.title" class="card-image">
              <div class="time-badge">
                <div class="time-icon"></div>
                <div class="time-text">{{ item.startTime.replace(/-/g, '.') }}-{{ item.endTime.replace(/-/g, '.') }}</div>
              </div>
            </div>

            <!-- 卡片内容 -->
            <div class="card-content">
              <h2 class="card-title">{{ item.title }}</h2>

              <!-- 竞赛数量 -->
              <div class="card-info">
                <div class="info-label">{{ globalDataArray.siteTemplateLanguage.zone_competition_count }}</div>
                <div class="info-value">
                  <div class="layer-icon i-icons:layer size-16"></div>
                  <div class="count-text">{{ item.competitionCount }}</div>
                </div>
              </div>

              <hr class="card-divider">

              <!-- 主办方信息 -->
              <div class="card-info">
                <div class="info-label">{{ globalDataArray.siteTemplateLanguage.zone_sponsor }}</div>
                <div class="sponsor-info">
                  <div class="building-icon i-icons:building size-16 shrink-0"></div>
                  <div class="sponsor-text" :title="item.sponsor">{{ item.sponsor }}</div>
                </div>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getZoneList } from '@/api/zone'
import { getAdList } from '@/api/api'

export default {
  name: 'Zone',

  data() {
    return {
      title: this.globalDataArray.siteNavigation[1].title + '-' + this.globalDataArray.siteInfo.title,
      description: this.globalDataArray.siteNavigation[1].keywords,
      keywords: this.globalDataArray.siteNavigation[1].description,

      banners: [],
      zoneListing: [],
      search: '',

      swiperOption: {
        autoplay: 5000,
        initialSlide: 0,
        // loop: true,
        pagination: '.swiper-pagination'
      }
    }
  },

  mounted() {
    this.getAdList()
    this.getZoneList()
  },

  methods: {
    async getAdList() {
      const { success, result } = await getAdList('alias=zonelist_banner')

      if (success) {
        this.banners = result
      }
    },

    async getZoneList() {
      const { success, result } = await getZoneList(this.search)

      if (success) {
        this.zoneListing = result
      }
    }
  },

  metaInfo() {
    let title = ''
    let description = ''
    let keywords = ''

    title = this.globalDataArray.siteTemplateLanguage.zone_page_title + '-' + this.globalDataArray.siteInfo.title
    description = this.globalDataArray.siteInfo.description
    keywords = this.globalDataArray.siteInfo.keywords

    return {
      title: title,
      meta: [
        { vmid: 'description', name: 'description', content: description },
        { vmid: 'keywords', name: 'keywords', content: keywords }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
/* ===========================================
   基础样式设置
   =========================================== */
.zone-page {
  background-color: #EFF6FE;
  min-height: 100vh;
  width: 100%;
}

/* ===========================================
   Banner轮播区域
   =========================================== */
.zone-banner {
  width: 100%;
  max-width: 100vw;
  overflow: hidden;
}

.banner-item {
  width: 100%;
  height: 26vw;
  max-height: 500px;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* ===========================================
   主容器样式
   =========================================== */
.zone-container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 2vw 2.8vw 11.1vw;
}

/* ===========================================
   搜索框样式
   =========================================== */
.search-box {
  height: 3.4em;
  max-height: 56px;
  min-height: 40px;
  background: white;
  border-radius: 2.8vw;
  display: flex;
  align-items: center;
  border: #afafae 1px solid;
  margin-bottom: 2.8vw;
  transition: all 0.4s;

  &:hover {
    border: #1281ff 1px solid;
  }
}

.search-icon {
  width: 1.39vw;
  max-width: 20px;
  min-width: 16px;
  height: 1.39vw;
  max-height: 20px;
  min-height: 16px;
  margin-left: 1.25vw;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23BBBDBF' viewBox='0 0 24 24'%3E%3Cpath d='M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z'/%3E%3C/svg%3E");
  background-size: contain;
  background-repeat: no-repeat;
  flex-shrink: 0;
}

.search-input {
  width: 100%;
  margin-left: 0.69vw;
  margin-right: 2.08vw;
  border: none;
  outline: none;
  font-size: calc(0.5rem + 0.5vw);
  color: #5D5D5B;
  background: transparent;

  &::placeholder {
    color: #BBBDBF;
  }
}

/* ===========================================
   赛区列表样式
   =========================================== */
.zone-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 1.39vw;
  margin-top: 2.8vw;
  list-style: none;
  padding: 0;
}

.zone-card {
  background: white;
  border-radius: 1.11vw;
  border: 1px solid rgba(207, 219, 213, 0.6);
  overflow: hidden;
  transition: all 0.4s;
  width: calc(31.5% - 0.93vw);
  min-height: 25.6vw;
  max-height: 469px;
  min-width: 280px;
  flex-shrink: 0;

  &:hover {
    transform: translateY(-0.28vw);
    box-shadow: 0 0.56vw 1.67vw rgba(0, 0, 0, 0.12);
  }
}

.zone-link {
  display: block;
  height: 100%;
  text-decoration: none;
  color: inherit;
}

/* ===========================================
   卡片图片区域 - 防止变形
   =========================================== */
.card-image-container {
  position: relative;
  width: 100%;
  height: 21vw;
  max-height: 302px;
  min-height: 180px;
  overflow: hidden;
  background: #f5f5f5;
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
  transition: all 0.6s;
}

.zone-card:hover .card-image {
  transform: scale(1.08);
}

.time-badge {
  position: absolute;
  top: 0.83vw;
  left: 0.83vw;
  background: white;
  border-radius: 1.6vw;
  border: 1px solid rgba(207, 219, 213, 0.6);
  height: 3.2vw;
  max-height: 46px;
  min-height: 32px;
  display: flex;
  align-items: center;
  padding: 0 1.11vw;
  font-size: calc(0.6rem + 0.4vw);
  font-weight: 600;
  line-height: 1.57;
  z-index: 2;
  box-shadow: 0 0.14vw 0.56vw rgba(0, 0, 0, 0.1);
}

.time-icon {
  width: 1.25vw;
  max-width: 18px;
  min-width: 14px;
  height: 1.25vw;
  max-height: 18px;
  min-height: 14px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23666' viewBox='0 0 24 24'%3E%3Cpath d='M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z'/%3E%3Cpath d='m12.5 7-1 0 0 6 5.25 3.15.75-1.23-4.5-2.67z'/%3E%3C/svg%3E");
  background-size: contain;
  background-repeat: no-repeat;
  margin-right: 0.56vw;
  flex-shrink: 0;
}

.time-text {
  color: #333;
  white-space: nowrap;
}

/* ===========================================
   卡片内容区域
   =========================================== */
.card-content {
  padding: 1.11vw;
  display: flex;
  flex-direction: column;
  height: calc(32.6vw - 21vw);
  max-height: calc(469px - 269px);
  min-height: 140px;
}

.card-title {
  font-size: calc(0.8rem + 0.6vw);
  font-weight: 600;
  line-height: 1.33;
  color: #333;
  margin: 0 0 1.95vw 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 0;
  transition: all 0.6s;

  &:hover {
    color: #1281ff;
  }
}

.card-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  //margin-bottom: 1.11vw;
  flex-shrink: 0;
}

.info-label {
  font-size: calc(0.5rem + 0.3vw);
  line-height: 1.5;
  color: #687489;
  font-weight: 500;
}

.info-value {
  display: flex;
  align-items: center;
}

.layer-icon {
  width: 1.11vw;
  max-width: 16px;
  min-width: 12px;
  height: 1.11vw;
  max-height: 16px;
  min-height: 12px;
  //background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23333' viewBox='0 0 24 24'%3E%3Cpath d='M12 2 2 7v10c0 5.55 3.84 9.64 9 11 5.16-1.36 9-5.45 9-11V7l-10-5z'/%3E%3C/svg%3E");
  background-size: contain;
  background-repeat: no-repeat;
  margin-right: 0.28vw;
}

.count-text {
  font-size: calc(0.7rem + 0.5vw);
  font-weight: 600;
  line-height: 1.5;
  color: #333;
}

.card-divider {
  height: 1px;
  background: rgba(207, 219, 213, 0.6);
  border: none;
  margin: 0 0 1.11vw 0;
  flex-shrink: 0;
}

.sponsor-info {
  display: flex;
  align-items: center;
  max-width: 18.06vw;
  min-width: 0;
}

.building-icon {
  width: 1.11vw;
  max-width: 16px;
  min-width: 12px;
  height: 1.11vw;
  max-height: 16px;
  min-height: 12px;
  //background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23333' viewBox='0 0 24 24'%3E%3Cpath d='M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z'/%3E%3C/svg%3E");
  background-size: contain;
  background-repeat: no-repeat;
  margin-right: 0.28vw;
  flex-shrink: 0;
}

.sponsor-text {
  font-size: calc(0.6rem + 0.4vw);
  font-weight: 400;
  line-height: 1.57;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  transition: all 0.6s;

  &:hover {
    color: #1281ff;
  }
}

/* ===========================================
   响应式媒体查询 - 更细致的断点
   =========================================== */

/* 超大屏幕 (≥1600px) */
@media screen and (min-width: 1600px) {
  .zone-container {
    max-width: 1440px;
    padding: 10px 40px 160px;
  }

  .zone-list {
    gap: 55px;
  }

  .zone-card {
    width: calc(31.5% - 13.33px);
  }
}

/* 大屏幕 (1200px - 1599px) */
@media screen and (min-width: 1200px) and (max-width: 1599px) {
  .zone-container {
    padding: 1.6vw 3vw 10vw;
  }

  .zone-list {
    gap: 3.5vw;
  }

  .zone-card {
    width: calc(31.5% - 1vw);
  }
}

/* 中等屏幕 (1024px - 1199px) */
@media screen and (min-width: 1024px) and (max-width: 1199px) {
  .zone-container {
    padding: 1.6vw 3vw 8vw;
  }

  .zone-list {
    justify-content: center;
    gap: 3.3vw;
  }

  .zone-card {
    width: calc(31.5% - 1vw);
    max-height: 395px
  }

  .card-image-container {
    height: 260px;
  }

  .card-content {
    height: calc(420px - 260px);
  }

  .banner-item {
    height: 21vw;
  }
}

/* 平板屏幕 (768px - 1023px) */
@media screen and (min-width: 768px) and (max-width: 1023px) {
  .zone-container {
    padding: 3vw 4vw 8vw;
  }

  .zone-list {
    justify-content: flex-start;
    //gap: 2.8vw;
  }

  .zone-card {
    width: calc(31.5% - 1.5vw);
    //min-height: 380px;
    max-height: 370px;
  }

  .card-image-container {
    height: 240px;
  }

  .card-content {
    height: calc(380px - 240px);
    padding: 16px;
  }

  .banner-item {
    height: 19vw;
  }

  .search-box {
    height: 48px;
    border-radius: 24px;
    margin-bottom: 24px;
  }

  .search-icon {
    width: 18px;
    height: 18px;
    margin-left: 16px;
  }

  .search-input {
    font-size: 14px;
    margin-right: 16px;
  }

  .time-badge {
    height: 36px;
    padding: 0 12px;
    font-size: 12px;
    top: 8px;
    left: 8px;
  }

  .time-icon {
    width: 14px;
    height: 14px;
  }
}

/* 手机屏幕 (≤767px) */
@media screen and (max-width: 767px) {
  .zone-container {
    padding: 5% 4% 8%;
  }

  .zone-list {
    justify-content: center;
    gap: 5%;
    margin-top: 5%;
  }

  .zone-card {
    width: 100%;
    max-width: 40px;
    //min-height: 350px;
    margin-top: 20px;
    max-height: 320px;
  }

  .card-image-container {
    height: 200px;
  }

  .card-content {
    height: calc(350px - 250px);
    min-height: 102px;
    padding: 4%;
  }

  .banner-item {
    height: 31vw;
    min-height: 200px;
  }

  .search-box-container {
    padding: 15px;
  }

  .search-second {
    padding: 0 10px;
  }

  .search-box {
    height: 48px;
    border-radius: 24px;
    margin: 15px auto;
    width: 100%;
    max-width: none;
  }

  .search-icon {
    width: 18px;
    height: 18px;
    margin-left: 16px;
  }

  .search-input {
    font-size: 14px;
    margin-right: 16px;
  }

  .card-title {
    font-size: 16px;
    line-height: 1.4;
    margin-bottom: 5%;
  }

  .time-badge {
    height: 32px;
    padding: 0 3%;
    font-size: 12px;
    top: 3%;
    left: 3%;
    border-radius: 16px;
  }

  .time-icon {
    width: 14px;
    height: 14px;
  }

  .sponsor-info {
    max-width: calc(100% - 60px);
  }

  .info-label {
    font-size: 11px;
  }

  .sponsor-text {
    font-size: 13px;
  }

  .count-text {
    font-size: 15px;
  }
}

/* 灰度模式 */
.bigEventGray {
  filter: grayscale(100%);
}

/* 悬停效果优化 */
@media (hover: hover) {
  .zone-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
  }

  .zone-card:hover .card-image {
    transform: scale(1.08);
  }
}

/* 减少动画的用户偏好 */
@media (prefers-reduced-motion: reduce) {
  .zone-card,
  .card-image,
  .card-title,
  .sponsor-text,
  .search-box {
    transition: none;
  }

  .zone-card:hover {
    transform: none;
  }

  .zone-card:hover .card-image {
    transform: none;
  }
}

//搜索框
.search-box-container {
  background-color: #fff;
  padding: 20px;
  margin-bottom: 16px;
}
.search-second{
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.search-box {
  position: relative;
  width: 100%;
  max-width: 600px;
  margin: 20px auto;
}
</style>

